/**
 * Date utility functions for the booking engine
 */

/**
 * Format a date to YYYY-MM-DD
 */
export const formatDate = (date) => {
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

/**
 * Format a date for display (e.g., "Mon, 15 Jan")
 */
export const formatDisplayDate = (date) => {
  if (!date) return '';
  const d = new Date(date);
  const day = d.getDate();
  const month = d.toLocaleString('default', { month: 'short' });
  const dayName = d.toLocaleString('default', { weekday: 'short' });
  return `${dayName}, ${day} ${month}`;
};

/**
 * Add months to a date
 */
export const addMonths = (date, months) => {
  const result = new Date(date);
  result.setMonth(result.getMonth() + months);
  return result;
};

/**
 * Get the number of days between two dates
 */
export const getDaysBetween = (start, end) => {
  const diffTime = Math.abs(end - start);
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
};

/**
 * Check if a value is a valid date string (not null, undefined, empty, 'Invalid Date', etc.)
 * @param {*} value - The value to check
 * @returns {boolean} True if the value can be parsed into a valid Date
 */
export const isValidDateString = (value) => {
  if (!value || value === 'Invalid Date') return false;
  if (typeof value !== 'string' && typeof value !== 'number') return false;
  const date = new Date(value);
  return !isNaN(date.getTime());
}; 